
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/data',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/data/',
            getPage: () => import(
              /* webpackChunkName: "data" */
              '/work/data-docs/_site_tmp/_data.js'
            ),
            
            
          },{
            path: '/data/boundaries/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries" */
              '/work/data-docs/_site_tmp/_data_boundaries.js'
            ),
            
            
          },{
            path: '/data/boundaries/changelog/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-changelog" */
              '/work/data-docs/_site_tmp/_data_boundaries_changelog.js'
            ),
            
            
          },{
            path: '/data/boundaries/guides/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-guides" */
              '/work/data-docs/_site_tmp/_data_boundaries_guides.js'
            ),
            
            
          },{
            path: '/data/boundaries/guides/boundaries-v4-migration-guide/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-guides-boundaries-v4-migration-guide" */
              '/work/data-docs/_site_tmp/_data_boundaries_guides_boundaries-v4-migration-guide.js'
            ),
            
            
          },{
            path: '/data/boundaries/guides/sample-workflow/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-guides-sample-workflow" */
              '/work/data-docs/_site_tmp/_data_boundaries_guides_sample-workflow.js'
            ),
            
            
          },{
            path: '/data/boundaries/guides/use-boundaries/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-guides-use-boundaries" */
              '/work/data-docs/_site_tmp/_data_boundaries_guides_use-boundaries.js'
            ),
            
            
          },{
            path: '/data/boundaries/reference/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-reference" */
              '/work/data-docs/_site_tmp/_data_boundaries_reference.js'
            ),
            
            
          },{
            path: '/data/boundaries/reference/mapbox-boundaries-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-reference-mapbox-boundaries-v1" */
              '/work/data-docs/_site_tmp/_data_boundaries_reference_mapbox-boundaries-v1.js'
            ),
            
            
          },{
            path: '/data/boundaries/reference/mapbox-boundaries-v2/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-reference-mapbox-boundaries-v2" */
              '/work/data-docs/_site_tmp/_data_boundaries_reference_mapbox-boundaries-v2.js'
            ),
            
            
          },{
            path: '/data/boundaries/reference/mapbox-boundaries-v3/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-reference-mapbox-boundaries-v3" */
              '/work/data-docs/_site_tmp/_data_boundaries_reference_mapbox-boundaries-v3.js'
            ),
            
            
          },{
            path: '/data/boundaries/reference/mapbox-boundaries-v4/',
            getPage: () => import(
              /* webpackChunkName: "data-boundaries-reference-mapbox-boundaries-v4" */
              '/work/data-docs/_site_tmp/_data_boundaries_reference_mapbox-boundaries-v4.js'
            ),
            
            
          },{
            path: '/data/movement/',
            getPage: () => import(
              /* webpackChunkName: "data-movement" */
              '/work/data-docs/_site_tmp/_data_movement.js'
            ),
            
            
          },{
            path: '/data/movement/guides/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides" */
              '/work/data-docs/_site_tmp/_data_movement_guides.js'
            ),
            
            
          },{
            path: '/data/movement/guides/activity-index/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides-activity-index" */
              '/work/data-docs/_site_tmp/_data_movement_guides_activity-index.js'
            ),
            
            
          },{
            path: '/data/movement/guides/data-format/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides-data-format" */
              '/work/data-docs/_site_tmp/_data_movement_guides_data-format.js'
            ),
            
            
          },{
            path: '/data/movement/guides/data-processing-guidelines/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides-data-processing-guidelines" */
              '/work/data-docs/_site_tmp/_data_movement_guides_data-processing-guidelines.js'
            ),
            
            
          },{
            path: '/data/movement/guides/download/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides-download" */
              '/work/data-docs/_site_tmp/_data_movement_guides_download.js'
            ),
            
            
          },{
            path: '/data/movement/guides/sample-data-and-examples/',
            getPage: () => import(
              /* webpackChunkName: "data-movement-guides-sample-data-and-examples" */
              '/work/data-docs/_site_tmp/_data_movement_guides_sample-data-and-examples.js'
            ),
            
            
          },{
            path: '/data/tilesets/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets" */
              '/work/data-docs/_site_tmp/_data_tilesets.js'
            ),
            
            
          },{
            path: '/data/tilesets/guides/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-guides" */
              '/work/data-docs/_site_tmp/_data_tilesets_guides.js'
            ),
            
            
          },{
            path: '/data/tilesets/guides/access-elevation-data/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-guides-access-elevation-data" */
              '/work/data-docs/_site_tmp/_data_tilesets_guides_access-elevation-data.js'
            ),
            
            
          },{
            path: '/data/tilesets/guides/imagery/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-guides-imagery" */
              '/work/data-docs/_site_tmp/_data_tilesets_guides_imagery.js'
            ),
            
            
          },{
            path: '/data/tilesets/guides/vector-tiles-introduction/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-guides-vector-tiles-introduction" */
              '/work/data-docs/_site_tmp/_data_tilesets_guides_vector-tiles-introduction.js'
            ),
            
            
          },{
            path: '/data/tilesets/guides/vector-tiles-standards/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-guides-vector-tiles-standards" */
              '/work/data-docs/_site_tmp/_data_tilesets_guides_vector-tiles-standards.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/legacy/mapbox-streets-v5/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-legacy-mapbox-streets-v5" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_legacy_mapbox-streets-v5.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/legacy/mapbox-streets-v6/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-legacy-mapbox-streets-v6" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_legacy_mapbox-streets-v6.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/legacy/mapbox-streets-v7/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-legacy-mapbox-streets-v7" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_legacy_mapbox-streets-v7.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-bathymetry-v2/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-bathymetry-v2" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-bathymetry-v2.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-countries-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-countries-v1" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-countries-v1.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-countries/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-countries" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-countries.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-indoor-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-indoor-v1" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-indoor-v1.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-naip/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-naip" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-naip.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-satellite/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-satellite" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-satellite.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-streets-v8/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-streets-v8" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-streets-v8.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-streets/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-streets" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-streets.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-terrain-dem-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-terrain-dem-v1" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-terrain-dem-v1.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-terrain-rgb-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-terrain-rgb-v1" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-terrain-rgb-v1.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-terrain-v2/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-terrain-v2" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-terrain-v2.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-terrain/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-terrain" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-terrain.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-traffic-v1/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-traffic-v1" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-traffic-v1.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-traffic/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-traffic" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-traffic.js'
            ),
            
            
          },{
            path: '/data/tilesets/reference/mapbox-transit-v2/',
            getPage: () => import(
              /* webpackChunkName: "data-tilesets-reference-mapbox-transit-v2" */
              '/work/data-docs/_site_tmp/_data_tilesets_reference_mapbox-transit-v2.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs" */
              '/work/data-docs/_site_tmp/_data_traffic-signs.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/reference/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs-reference" */
              '/work/data-docs/_site_tmp/_data_traffic-signs_reference.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/reference/china/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs-reference-china" */
              '/work/data-docs/_site_tmp/_data_traffic-signs_reference_china.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/reference/europe/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs-reference-europe" */
              '/work/data-docs/_site_tmp/_data_traffic-signs_reference_europe.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/reference/japan/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs-reference-japan" */
              '/work/data-docs/_site_tmp/_data_traffic-signs_reference_japan.js'
            ),
            
            
          },{
            path: '/data/traffic-signs/reference/usa/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-signs-reference-usa" */
              '/work/data-docs/_site_tmp/_data_traffic-signs_reference_usa.js'
            ),
            
            
          },{
            path: '/data/traffic/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic" */
              '/work/data-docs/_site_tmp/_data_traffic.js'
            ),
            
            
          },{
            path: '/data/traffic/guides/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-guides" */
              '/work/data-docs/_site_tmp/_data_traffic_guides.js'
            ),
            
            
          },{
            path: '/data/traffic/guides/access/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-guides-access" */
              '/work/data-docs/_site_tmp/_data_traffic_guides_access.js'
            ),
            
            
          },{
            path: '/data/traffic/guides/data/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-guides-data" */
              '/work/data-docs/_site_tmp/_data_traffic_guides_data.js'
            ),
            
            
          },{
            path: '/data/traffic/guides/example/',
            getPage: () => import(
              /* webpackChunkName: "data-traffic-guides-example" */
              '/work/data-docs/_site_tmp/_data_traffic_guides_example.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };